import { IFileInfo } from 'react-csv-reader';
import { CSVData, FSNModel, GoLiveFSNModel } from '../types/common';

import { VisualQCStatus } from './enums';
import { ArInfoOptions } from './constants/arMeta';

const FSN_ID_LENGTH = 16;
// const CSV_ROWS = 50;

export const validateCSV = (csvData: any[], fileInfo: IFileInfo) => {
    if (fileInfo.type !== 'text/csv' || fileInfo.name.split('.')[1] !== 'csv') {
        return { valid: false, error: 'Not a valid CSV file' };
    }
    return isAlphaNumeric(csvData);
};

const isAlphaNumeric = (csvData: any[]) => {
    for (const fsn of csvData) {
        if (fsn.length !== 1) {
            return { valid: false, error: 'CSV contains more than 1 column' };
        } else {
            if (fsn[0].trim()?.length === 0) {
                continue;
            } else if (fsn[0].match(/^([0-9]|[A-Z])+([0-9A-Z]+)$/)) {
                continue;
            } else {
                return { valid: false, error: 'Some FSNs are wrong, please check' };
            }
        }
    }
    return { valid: true };
    // return true;
};

export const validateGoLiveCSV = (csvData: CSVData[], fileInfo: IFileInfo) => {
    if (fileInfo.type !== 'text/csv' || fileInfo.name.split('.')[1] !== 'csv') {
        return { valid: false, error: 'Not a valid CSV file' };
    }

    // if (csvData.length > CSV_ROWS) {
    //     return { valid: false, error: `you can go live upto ${CSV_ROWS} FSNs only` };
    // }

    for (const fsn of csvData) {
        const { fsn_id, guardrails_status, fitfor3dinpp_status, visualqc_message, visualqc_status, model, guardrails_message } = fsn;

        if (!fsn_id) {
            return { valid: false, error: 'Please remove Empty line from csv and try again.' };
        } else if (fsn_id.length !== FSN_ID_LENGTH) {
            return { valid: false, error: 'FSN Length should not be more than 16 characters' };
        } else if (guardrails_status && typeof guardrails_status !== 'boolean') {
            return { valid: false, error: 'Guardrails Status should be boolean' };
        } else if (fitfor3dinpp_status && typeof fitfor3dinpp_status !== 'boolean') {
            return { valid: false, error: 'Fit for 3dinpp Status should be boolean' };
        } else if (visualqc_status && !['PENDING', 'FAILED', 'PASSED'].includes(visualqc_status)) {
            return { valid: false, error: 'Visual QC Status os one of these type: "PENDING","FAILED","PASSED" ' };
        } else if (visualqc_message && typeof visualqc_message !== 'string') {
            return { valid: false, error: 'Visual QC Message should be string' };
        } else if (model && typeof model !== 'string') {
            return { valid: false, error: 'Model should be string' };
        } else if (guardrails_message && typeof guardrails_message !== 'string') {
            return { valid: false, error: 'Guardrails Message should be string' };
        }
    }

    return { valid: true };
};

export const generateCSVData = (fsns: FSNModel[] | null) => {
    return fsns?.map((item) => ({
        fsn: item.fsn,
        guardRailsStatus: item.status,
        fitFor3DInPP: item.fitFor3DInPP || false,
        visualQCStatus: item.visualQCStatus,
        guardRailsMessage: item.error?.message ? item.error.message : JSON.stringify({}),
        visualQCMessage: '',
        modelUrl: item.url
    }));
};

export const convertCSVtoFSNData = (csvData: CSVData[]): GoLiveFSNModel[] => {
    let newFsns = csvData.map((item) => ({
        fsn: item['fsn_id'],
        arInfoData: ArInfoOptions[0],
        status: item['guardrails_status'] || true,
        fitFor3DInPP: item['fitfor3dinpp_status'] || false,
        url: item['model'] ?? `https://static-assets-web.flixcart.com/arm/glb/${item['fsn_id']}.glb`, //TODO: need to check should we add any number like _2 in path
        visualQCStatus: item['visualqc_status'] ?? VisualQCStatus.PASSED,
        visualQCMessage: item['visualqc_message'] ?? ''
    }));

    newFsns = newFsns?.filter((item) => item.status && item.visualQCStatus === VisualQCStatus.PASSED);
    return newFsns;
};

export const validateGlb = (fileList: FileList) => {
    for (let i = 0; i < fileList.length; i++) {
        const file = fileList[i];

        const filename = file.name.split('.')[0];

        if (filename.length !== FSN_ID_LENGTH) {
            return { valid: false, error: `File name should have 16 characters only e.g: BDDF5YZYNZGH8AZC . currently have ${filename.length} characers` };
        }
    }

    return { valid: true };
};
